module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/star1.a7dfb93c.png";